export function split(source) {
    const result = [];
    let current = '';
    const splitChars = ['<', '>', '"', '=', ' ', '?', '/', '{', '}', '\n', '.', '[', ']', '(', ')', ':'];
    for (let i = 0; i < source.length; i++) {
        const char = source.charAt(i);
        if (splitChars.indexOf(char) >= 0) {
            result.push(current);
            current = '';
            result.push(char);
            continue;
        }
        current += char;
    }
    return result;
}
